
export default function Footer() {
  return (
    <footer className="bg-black border-t-2 border-[#D4AF37]">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Block */}
          <div className="lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/521161dc8188d5a0deb9a03b30fe0200/d584313f1887d86954b216b87d4f054b.png"
              alt="PremierNY Logo"
              className="h-12 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm italic leading-relaxed">
              Experiências de luxo em Nova York, criadas pelos seus especialistas brasileiros de
              confiança.
            </p>
            <div className="flex gap-4 mt-6">
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center border-2 border-[#D4AF37] rounded-full text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black transition-all duration-300"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://wa.me/16466330270"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border-2 border-[#D4AF37] rounded-full text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black transition-all duration-300"
              >
                <i className="ri-whatsapp-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="text-[#D4AF37] text-sm uppercase tracking-wider font-bold mb-4">
              Serviços
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="#services"
                  className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm"
                >
                  Roteiros Personalizados
                </a>
              </li>
              <li>
                <a
                  href="#services"
                  className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm"
                >
                  Passeios Guiados
                </a>
              </li>
              <li>
                <a
                  href="#services"
                  className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm"
                >
                  Assistência no Aeroporto
                </a>
              </li>
              <li>
                <a
                  href="#services"
                  className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm"
                >
                  Planejamento de Viagem
                </a>
              </li>
              <li>
                <a
                  href="#packages"
                  className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm"
                >
                  Experiências VIP
                </a>
              </li>
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h4 className="text-[#D4AF37] text-sm uppercase tracking-wider font-bold mb-4">
              Empresa
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="#testimonials"
                  className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm"
                >
                  Depoimentos
                </a>
              </li>
              <li>
                <a
                  href="#packages"
                  className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm"
                >
                  Pacotes
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm"
                >
                  Sobre Nós
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm"
                >
                  Perguntas Frequentes
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm"
                >
                  Blog
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Block */}
          <div>
            <h4 className="text-[#D4AF37] text-sm uppercase tracking-wider font-bold mb-4">
              Contato
            </h4>
            <div className="space-y-4">
              <a
                href="https://wa.me/16466330270"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 px-4 py-3 bg-[#25D366] text-white rounded-lg hover:bg-[#20BA5A] transition-colors text-sm font-semibold whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                WhatsApp PremierNY
              </a>
              <div className="flex items-start gap-3 text-gray-400 text-sm">
                <i className="ri-mail-line text-[#D4AF37] text-xl mt-0.5"></i>
                <div>
                  <p className="font-semibold text-white mb-1">E-mail</p>
                  <a
                    href="mailto:contatopremierny@gmail.com"
                    className="hover:text-[#D4AF37] transition-colors"
                  >
                    contatopremierny@gmail.com
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3 text-gray-400 text-sm">
                <i className="ri-map-pin-line text-[#D4AF37] text-xl mt-0.5"></i>
                <div>
                  <p className="font-semibold text-white mb-1">Localização</p>
                  <p>Nova York, NY</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Copyright Bar */}
      <div className="bg-[#0f0f0f] border-t border-[#D4AF37]/20">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">© 2024 PremierNY. Todos os direitos reservados.</p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-gray-500 hover:text-[#D4AF37] transition-colors text-sm">
              Política de Privacidade
            </a>
            <span className="text-[#D4AF37]">•</span>
            <a href="#" className="text-gray-500 hover:text-[#D4AF37] transition-colors text-sm">
              Termos de Uso
            </a>
            <span className="text-[#D4AF37]">•</span>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-[#D4AF37] transition-colors text-sm"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
